<template>
  <wc-dialog
    :showDialog='showDialog'
    title='New Invoice'
    :icon='$store.state.icons.dataBox.invoices.icon'
    iconColor='success'
    :loadingButtons='isSavingNewInvoice'
    :disableButtons='!isFormValid'
    @cancel="$emit('cancel')"
    @save='generateInvoice'
    saveText='Create Invoice'
    width='350'
  >
    <v-form v-model='isFormValid' ref='form'>
      <v-select
        :items='$store.state.misc.divisions'
        item-value='id'
        item-text='division'
        label='Division'
        v-model='newInvoice.division'
        :rules='[rules.required]'
      ></v-select>
      <v-autocomplete
        label='Bill to'
        :items='clientArr'
        item-value='id'
        item-text='name_display'
        v-model='newInvoice.bill_to'
        hint="Generally the 'works for' setting of a contact"
        persistent-hint
      ></v-autocomplete>
      <v-autocomplete
        label='Send to'
        :items='clientArr'
        item-value='id'
        item-text='name_display'
        hint="To whom an invoice is sent. If blank, the 'bill to' is used"
        persistent-hint
        v-model='newInvoice.send_to'
      ></v-autocomplete>
    </v-form>
  </wc-dialog>
</template>

<script>
import accountingAPI from '@/api/accounting';
import formRules from '@/mixins/formRules';
import moment from 'moment';

export default {
  name: 'new-invoice-dialog',
  mixins: [formRules],
  props: {
    billTo: {
      required: false,
      type: Object
    },
    clients: {
      required: false
    },
    showDialog: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    isSavingNewInvoice: false,
    newInvoice: {
      division: '',
      bill_to: null,
      send_to: null,
      wo_type: null,
      invoice_date: ''
    },
  }),
  computed: {
    clientArr () {
      if (this.billTo) {
        let tmp = []
        tmp.push(this.billTo)
        if (this.billTo.works_for) {
          tmp.push(this.billTo.works_for_obj)
        }
        return tmp
      }
      return this.clients
    },
    divisionCategories () {
      return this.categories.filter(c => c.division === this.newInvoice.division)
    },
    categories () {
      return this.$store.state.misc.woTypes.filter(t => t.archived === false)
    }
  },
  watch: {
    'newInvoice.division' () {
      this.newInvoice.wo_type = null
    },
    showDialog () {
      if (this.showDialog === true) {
        this.newInvoice.invoice_date = moment().format('YYYY-MM-DD').toString()
        this.newInvoice.division = null
        this.newInvoice.wo_type = null
        if (this.billTo) {
          if (this.billTo.works_for) {
            this.newInvoice.bill_to = this.billTo.works_for
            this.newInvoice.send_to = this.billTo.id
          } else {
            this.newInvoice.bill_to = this.billTo.id
            this.newInvoice.send_to = null
          }
        }
        setTimeout(() => {
          this.$refs.form.resetValidation()
        }, 100)
      }
    }
  },
  methods: {
    async generateInvoice () {
      console.log(this.newInvoice)
      let inv = await accountingAPI.createInvoice(this.newInvoice)
      this.$router.push({ name: 'InvoiceOverview', params: { id: inv.id } })
    }
  }
}
</script>
